var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#FC0000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.334 3.16667L13.1673 3.16667V3.5L12.334 3.5H11.834V4L11.834 14C11.834 14.3978 11.6759 14.7794 11.3946 15.0607C11.1133 15.342 10.7318 15.5 10.334 15.5L3.66732 15.5C3.26949 15.5 2.88796 15.342 2.60666 15.0607C2.32535 14.7794 2.16732 14.3978 2.16732 14L2.16732 4V3.5L1.66732 3.5H0.833984L0.833984 3.16667L3.66732 3.16667H4.16732V2.66667V1.33333C4.16732 1.11232 4.25512 0.900358 4.4114 0.744078C4.56768 0.587797 4.77964 0.5 5.00065 0.5L9.00065 0.5C9.22166 0.5 9.43363 0.587797 9.58991 0.744077C9.74619 0.900358 9.83398 1.11232 9.83398 1.33333V2.66667V3.16667L10.334 3.16667ZM5.00065 0.833333L4.50065 0.833333V1.33333V2.66667L4.50065 3.16667H5.00065L9.00065 3.16667H9.50065V2.66667V1.33333V0.833333H9.00065L5.00065 0.833333ZM3.00065 3.5H2.50065V4L2.50065 14C2.50065 14.3094 2.62357 14.6062 2.84236 14.825C3.06115 15.0438 3.3579 15.1667 3.66732 15.1667L10.334 15.1667C10.6434 15.1667 10.9402 15.0438 11.1589 14.825C11.3777 14.6062 11.5007 14.3094 11.5007 14L11.5007 4V3.5H11.0007L3.00065 3.5Z",
    fill: "#374957"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.4996L5.5 7.16626H5.83333L5.83333 11.4996H5.5Z",
    fill: "#374957"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16797 11.4996V7.16626H8.50131V11.4996H8.16797Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.5a6c4ca28a00e1b485aa96a5dc3c8639.svg";
export { ForwardRef as ReactComponent };